<div class="container">
  <div class="app-loading" *ngIf="appLoading">
    <div class="logo">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
    </div>
    <span>Caricamento...</span>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h1 rtl class="main-heading">Rate</h1>
    </div>
  </div>
  <div *ngIf="rate.length === 0">
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <p><img src="assets/cupido.png"/></p>
    </div>
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <p>Nessuna rata presente su questa pratica.</p>
    </div>
  </div>
  <div class="row" *ngIf="rate.length !== 0">
    <div class="col scroll-x">
      <table mat-table [dataSource]="rate" class="mat-elevation-z8">
        <ng-container matColumnDef="numero">
          <th mat-header-cell *matHeaderCellDef> N° </th>
          <td mat-cell *matCellDef="let rata "> {{ rata.vmepNumeroRata }} </td>
        </ng-container>
        <ng-container matColumnDef="dataScadenza">
          <th mat-header-cell *matHeaderCellDef> Scadenza </th>
          <td mat-cell *matCellDef="let rata"> {{ rata.vmepDataRiferimento | date: 'MM/yyyy' }} </td>
        </ng-container>
        <ng-container matColumnDef="importo">
          <th mat-header-cell *matHeaderCellDef> Importo </th>
          <td mat-cell *matCellDef="let rata"><strong> {{ rata.vmepInsoluto + rata.vmepTotaleIncassato | currency:'EUR' }} </strong></td>
        </ng-container>
        <ng-container matColumnDef="capitale">
          <th mat-header-cell *matHeaderCellDef> Capitale </th>
          <td mat-cell *matCellDef="let rata"> {{ rata.vmepInsolutoCapitale + rata.vmepTotaleIncassatoCapitale | currency:'EUR' }} </td>
        </ng-container>
        <ng-container matColumnDef="interessi">
          <th mat-header-cell *matHeaderCellDef> Interessi </th>
          <td mat-cell *matCellDef="let rata"> {{ rata.vmepInsolutoInteressi + rata.vmepTotaleIncassatoInteressi | currency:'EUR' }} </td>
        </ng-container>
        <ng-container matColumnDef="stato">
          <th mat-header-cell class="align-right" *matHeaderCellDef>Stato</th>
          <td mat-cell class="align-right" *matCellDef="let rata ">
            <mat-chip selected disabled *ngIf="(today | date:'yMMdd') <= (rata.vmepDataRiferimento| date:'yMMdd')" >Futura</mat-chip>
            <mat-chip selected color="primary" *ngIf="rata.vmepInsoluto == 0">Pagata</mat-chip>
            <mat-chip selected color="accent" *ngIf="rata.vmepTotaleIncassato > 0 && rata.vmepInsoluto > 0">Parziale</mat-chip>
            <mat-chip selected color="warn" *ngIf="(today | date:'yMMdd') > (rata.vmepDataRiferimento| date:'yMMdd') && rata.vmepTotaleIncassato == 0">Scaduta</mat-chip>
          </td>
        </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


    </div>
  </div>
</div>
